import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AdvertisementModal from './AdvertisementModal';
import styles from './Advertisements.module.scss';
import { Button } from 'semantic-ui-react';

const Advertisements = ({ profile, onGoToEDelivery, actions, advertisement }) => {
	const { dontShowAdvertisement, dontShowEDelivery, isDelivery } = profile;
	
	const [isOpen, setIsOpen] = useState(true);

	if (!isDelivery && !dontShowEDelivery)
		return (
			<AdvertisementModal open={isOpen} onClose={() => setIsOpen(false)} header='Manage Your Alerts' onToggleDontShow={(_, { checked }) => actions.updateDontShowAd({ ...profile, dontShowEDelivery: checked })}>
				<div className={styles.paperless}>
					<div className={styles.big}>Go paperless, save time and save some trees.</div>
					<div>
						<Button onClick={onGoToEDelivery} positive>
							Sign me up
						</Button>
					</div>
				</div>
			</AdvertisementModal>
		);

	if (!dontShowAdvertisement && advertisement)
		return (
			<AdvertisementModal open={isOpen} onClose={() => setIsOpen(false)} header={advertisement.header} size={advertisement.size} onToggleDontShow={(_, { checked }) => actions.updateDontShowAd({ ...profile, dontShowAdvertisement: checked })}>
				<div dangerouslySetInnerHTML={{ __html: advertisement.bodyHtml }} />
			</AdvertisementModal>
		);

	return null;
};

Advertisements.propTypes = {
	profile: PropTypes.object.isRequired,
};

export default Advertisements;
